export interface PopularCategory {
  id: number;
  slug: string;
  name: string;
  path: string;
  createdAt: Date;
  updatedAt: Date;
}

export const popularCategoryFromResponse = (
  responseData: any,
): PopularCategory => ({
  id: responseData.id,
  slug: responseData.slug,
  name: responseData.name,
  path: responseData.path,
  createdAt: new Date(responseData.created_at),
  updatedAt: new Date(responseData.updated_at),
});
